import React from 'react'

import { useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import { useDialogStore } from '@stores/dialog.store'
import PageRoutes from '@utils/page-routes'

const OpenArchivedScoreDialog: React.FC = () => {
  const { t } = useTranslation()
  const state = useDialogStore<{ external_id: string }>((s) => s.state)

  return (
    <Dialog
      name="open_archived"
      title={t('action.openArchived')}
      maxWidth={400}
      okBtn={{
        action: () => (window.location.href = PageRoutes.editorPath(state.external_id)),
      }}
      cancelBtn>
      <p>{t('messages.openArchivedScore')}</p>
    </Dialog>
  )
}

export default OpenArchivedScoreDialog
